/**
 * Barriera contro la schermata bianca.
 *
 * Quando un componente React solleva un'eccezione durante il disegno, React
 * smonta tutto l'albero: la pagina compare per un istante e poi resta bianca,
 * senza una parola su cosa è andato storto. Qui l'errore si ferma, si mostra
 * in italiano con il pulsante per ricaricare, e si manda al server — così
 * domani si sa cosa correggere invece di chiedere "cosa stavi facendo?".
 */
import { Component } from 'react';

export default class BarrieraErrori extends Component {
  constructor(props) {
    super(props);
    this.state = { errore: null, inviato: false };
  }

  static getDerivedStateFromError(errore) {
    return { errore };
  }

  componentDidCatch(errore, info) {
    // La segnalazione è un di più: se non parte, la pagina resta comunque
    // leggibile e il pulsante di ricarica funziona.
    try {
      fetch('/api/errori-client', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(localStorage.getItem('token')
            ? { Authorization: `Bearer ${localStorage.getItem('token')}` } : {}),
        },
        body: JSON.stringify({
          messaggio: String(errore?.message || errore),
          stack: String(errore?.stack || '').slice(0, 4000),
          componenti: String(info?.componentStack || '').slice(0, 2000),
          percorso: window.location.pathname + window.location.search,
          agente: navigator.userAgent,
        }),
      }).then(() => this.setState({ inviato: true })).catch(() => {});
    } catch { /* niente da fare: l'importante è non peggiorare */ }
  }

  render() {
    const { errore, inviato } = this.state;
    if (!errore) return this.props.children;

    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
        <div className="bg-white border rounded-2xl shadow-lg max-w-xl w-full p-6">
          <h1 className="text-lg font-semibold text-gray-900">Questa pagina si è interrotta</h1>
          <p className="text-sm text-gray-600 mt-1.5">
            Il resto del gestionale funziona: i dati non sono stati toccati. Ricarica la pagina,
            e se succede di nuovo nello stesso punto segnalalo — l'errore è già stato registrato
            per noi.
          </p>

          <div className="mt-4 bg-gray-50 border rounded-lg p-3">
            <div className="text-xs font-medium text-gray-500">Dettaglio tecnico</div>
            <div className="text-xs font-mono text-red-700 mt-1 break-words">
              {String(errore?.message || errore)}
            </div>
            <div className="text-[11px] text-gray-400 mt-1">
              pagina: {window.location.pathname}
              {inviato ? ' · segnalato automaticamente' : ''}
            </div>
          </div>

          <div className="flex gap-2 mt-5">
            <button className="btn-primary" onClick={() => window.location.reload()}>
              Ricarica la pagina
            </button>
            <button className="btn-secondary" onClick={() => { window.location.href = '/'; }}>
              Torna alla dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}
